$(document).ready(function () {
//$('.quickshop .single-option-selector option').removeAttr("disabled");
  
  $("#SiteNavLabel-shop").hide();
    $("#SiteNavLabel-designers").hide();
    $(".custom-dropdown-menu").slideUp();
    $('.site-nav__link--button[aria-controls="SiteNavLabel-shop"]').click(function () {
        var $this = $(this);
       // $('.site-nav__link--button[aria-controls="SiteNavLabel-designers"]').removeClass('this_active');
        $this.toggleClass('this_active');
		$('.this_active').not(this).removeClass('this_active');
        var left_position = $this.offset().left
        $('.custom-dropdown-menu').not('.shop_menu').slideUp();
        $(".custom-dropdown-menu.shop_menu").slideToggle(); //.css("padding-left", left_position+15+'px');
    });
    $('.site-nav__link--button[aria-controls="SiteNavLabel-designers"]').click(function () {
        var $this = $(this);
       // $('.site-nav__link--button[aria-controls="SiteNavLabel-shop"]').removeClass('this_active');
        $this.toggleClass('this_active');
        $('.this_active').not(this).removeClass('this_active');
        var left_position = $this.offset().left
        $('.custom-dropdown-menu').not('.design_menu').slideUp();
      $(".custom-dropdown-menu.design_menu").slideToggle();//.css("padding-left", left_position+15+'px');
    });
    $('#mobileMenuBtn').click(function () {
      $('#main-header--mobile-nav').addClass('active');
    });
    $('#mobileMenuCloseBtn').click(function () {
      $('#main-header--mobile-nav').removeClass('active');
      $('.scroll-locked').removeClass('scroll-locked');
    });
    $('.dropdown-btn').click(function () {
      var $this = $(this);
      $this.toggleClass('dropdown-btn_active')
      var current_menu = $this.parent().parent('.dropdown').attr('aria-controls');
      $('#'+current_menu).slideToggle();
    });


    var firstChar = "";

    /*$(".site-nav.list--inline li a span.first_letter").each(function (index) {
        var tempFirstchar = $(this).text();
        if (firstChar != tempFirstchar) {
            firstChar = tempFirstchar;
            $(this).css("font-weight", "bold");
        }
    });
    */

    $(".custom-mega-menu .list-wrap li a span.first_letter").each(function (index) {
      var tempFirstchar = $(this).text();
      if (firstChar != tempFirstchar) {
        firstChar = tempFirstchar;
        $(this).css("font-weight", "bold");
        $(this).css("color", "#000");
      }
      
      
     /* $(".mobile-left").click(function(){
        $("#main-header--mobile-nav").addClass("active");
      });*/
});
  //$(".quickviewinstore").click(function(){
    
    $(document).on('click', '.quickviewinstore', function(event) {

  	$(".quickshop-visible").addClass('quickshop-loaded');
        
    $(".product-form-grid-select option").removeAttr("disabled");
    $('.quickshop .single-option-selector option').removeAttr("disabled");
    //$(".quickshop-content .select-wrapper span").html($(".single-option-selector option:selected").val());
	//$(".product-form-grid-select span[data-selected-option]").html($(".single-option-selector").val());

      var timer = setInterval(function() {
  
      if ($(".product-form-grid-select span[data-selected-option]").length > 0 ) {
        $(".product-form-grid-select span[data-selected-option]").html($(".single-option-selector").val());
        clearInterval(timer);
        }

      }, 200);

  });
  $(".quickviewinstore .quickshop-close").click(function(){
  	$(".quickshop").removeClass('quickshop-loaded');
    $(".quickshop").removeClass('quickshop-visible');
  });
  $(document).on('change', '.single-option-selector', function(event) {
    var curVal=$(this).val();
    $(this).parents(".product-form-grid-select").find("span[data-selected-option]").html(curVal);
    });
  

});

function ordinal_suffix_of(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}
$(window).on("load", function () {
   //$(".product-form-grid-select span[data-selected-option]").html($(".single-option-selector").val());
  var counter = 1;
  $('.article-item-div .article-date').each(function(){
    var date_for = $(this).data("day");
  	var date_for_monthyear = $(this).data("monthyear"); 
    $("#ad"+counter).html(ordinal_suffix_of(date_for)).append(date_for_monthyear);
    counter++;
  });
  
  var date_for = $(".article-date").data("day");
  var date_for_monthyear = $(".article-date").data("monthyear"); 
    $(".article-date label").html(ordinal_suffix_of(date_for)).append(date_for_monthyear);
});

